import React from "react"
import List from "./repasseList"
export default props => {
    const { contrato,extratoRedimento,anos } = props

    
    
    return (
        <>
            <div className="card-info-contrato row">
                <div className="col-xs-12 col-sm-6">
                    <p>
                        <strong>Endereço do Imóvel</strong>
                        <br />
                        {`(${contrato.imovel.codigo})`}
                        {contrato.imovel.endereco}
                    </p>
                </div>
                <div className="col-xs-6 col-sm-3">
                    <p>
                        <strong>Vigência</strong>: <br /> {contrato.vigencia}
                    </p>
                </div>
                <div className="col-xs-6 col-sm-3">
                    <p>
                        <strong>Extrato de Rendimento</strong>:
                        <div class="select">
                            <select onChange={(e)=>extratoRedimento(e.target.value)}>
                                <option>Selecione o ano</option>
                                {
                                anos.map(an => <option value={an}>{an}</option> )
                                }
                            </select>
                        </div>
                    </p>
                </div>
            </div>
            <br />
            <List repasses={contrato.repasses} title="Repasses" />
        </>
    )
}
